import './publicPath';
import { setupErrorHandling } from './error-handling';
import { initialiseGlobalSingletons } from './initialiseGlobalSingletons';

// Install global handlers first so errors during app initialisation are captured.
setupErrorHandling();

// Initialise localisation before bootstrap imports reducers that read it, and set the other
// window-backed singletons in the same step.
initialiseGlobalSingletons();

import(
  /* webpackChunkName: "Bootstrap" */
  './bootstrap'
)
  .then((bootstrap) => bootstrap.run())
  .catch((error) => {
    throw error;
  });

export {};
